//console.log('init_article.js loaded!');

/* css for the specific page */
import "./pages-assets/article/article.css";


   

/* scripts for the specific page */
import "./pages-assets/article/article.js";
// Sticky sidebar
// left column sticky content
//import "./components/gallery/gallery.js";
import(/* webpackPrefetch: true */ './components/gallery/gallery.js');

